/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Miss behaviour for this instance (LATE_ALLOWED or HARD_MISS)
 */
export enum ScheduledQuestionnaireListItemDtoMissBehaviour {
  LATE_ALLOWED = "LATE_ALLOWED",
  HARD_MISS = "HARD_MISS",
}
